import $ from 'jquery';

function loadShoppingBagCount(){
    return new Promise((resolve, reject) => {
    $.ajax({
        type: 'GET',
        url: '/content/shoppingbag/getMinibagMarkup',
        success: function(data){
          resolve(data);
        },
        failure: function(){},
        error: function(error) {
          reject(error);
        }
    });
  });
}

export default loadShoppingBagCount();


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/load-shopping-bag-count.js